"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PublicMetasController", {
    enumerable: true,
    get: function() {
        return PublicMetasController;
    }
});
const _common = require("@nestjs/common");
const _publicmetasservice = require("~/services/public-metas.service");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let PublicMetasController = class PublicMetasController {
    async viewMetaGet(context, req, sharedViewUuid) {
        var _req_headers;
        return await this.publicMetasService.viewMetaGet(context, {
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid
        });
    }
    async publicSharedBaseGet(context, sharedBaseUuid) {
        return await this.publicMetasService.publicSharedBaseGet(context, {
            sharedBaseUuid
        });
    }
    constructor(publicMetasService){
        this.publicMetasService = publicMetasService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/meta',
        '/api/v2/public/shared-view/:sharedViewUuid/meta'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicMetasController.prototype, "viewMetaGet", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-base/:sharedBaseUuid/meta',
        '/api/v2/public/shared-base/:sharedBaseUuid/meta'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sharedBaseUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicMetasController.prototype, "publicSharedBaseGet", null);
PublicMetasController = _ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _publicmetasservice.PublicMetasService === "undefined" ? Object : _publicmetasservice.PublicMetasService
    ])
], PublicMetasController);
